import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { IMAGES } from "../lib/site";

const Reveal = ({ children, delay = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.7, delay, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);

const About = () => {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-36 bg-black"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <Reveal>
          <div className="lg:col-span-5 relative">
            <div className="relative overflow-hidden rounded-sm border border-white/10">
              <img
                src={IMAGES.about}
                alt="Precision fade"
                className="w-full h-[420px] md:h-[560px] object-cover transition-transform duration-[1.2s] hover:scale-105"
                data-testid="about-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            </div>
            <div className="absolute -bottom-6 -right-6 h-24 w-24 bg-gold flex items-center justify-center rounded-sm hidden md:flex">
              <span className="font-display text-black text-2xl">EST.</span>
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-gold" />
              <span className="label-eyebrow text-gold">{t.about.eyebrow}</span>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tighter">
              {t.about.title}
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-white/70 text-base md:text-lg leading-relaxed max-w-2xl">
              {t.about.body}
            </p>
          </Reveal>

          <Reveal delay={0.3}>
            <div className="mt-12 grid grid-cols-3 gap-4 md:gap-8 max-w-xl">
              {[
                { n: "200+", l: t.about.stat2 },
                { n: "100%", l: t.about.stat3 },
                { n: "Ii", l: "Yliranta" },
              ].map((s, i) => (
                <div
                  key={i}
                  className="border-t border-white/10 pt-4"
                  data-testid={`about-stat-${i}`}
                >
                  <div className="font-display text-3xl md:text-4xl text-gold tracking-tight">
                    {s.n}
                  </div>
                  <div className="label-eyebrow text-white/50 mt-1">{s.l}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
